<template>
  <v-menu open-on-hover
          close-on-content-click
          location="bottom"
          transition="slide-y-transition"
          @update:model-value="onMenuToggle"
  >
    <template v-slot:activator="{ props }">
      <app-button
        :class="{'--is-active': $route.path === '/'}"
        type="icon"
        v-bind="props"
      >
        <app-material-icon name="home_storage" color="inherit" />
      </app-button>
    </template>

    <v-list class="py-0" :min-width="206">
      <v-list-subheader class="font-weight-medium text-uppercase"
                        style="font-size: 12px; position: sticky; top: 0; z-index: 10"
      >
        {{ $t('common.app-bar.ProjectsMenuItem.recentlyOpened') }}
      </v-list-subheader>

      <v-list-item v-if="lastVisitedRoomsPending">
        <v-progress-circular style="width: 32px; height: 32px"
                             size="32"
                             indeterminate
        />
      </v-list-item>

      <div v-else>
        <v-list-item v-for="project in lastVisitedRooms"
                     :key="project.id"
                     :active="roomMnemo === project.mnemo"
                     class="project-list-item"
                     @click="goToProject(project)"
        >
          <v-list-item-title class="d-flex align-end" style="font-size: 14px">
            <img class="mr-2"
                 alt="room-icon"
                 :src="getRoomIcon(project)"
                 width="24"
            />
            <span>
              {{ project.name.substr(0, 92) + (project.name.length > 92 ? '...' : '') }}
            </span>
          </v-list-item-title>
        </v-list-item>

        <v-divider/>

        <v-list-item @click="goToProjects">
          {{ $t('common.app-bar.ProjectsMenuItem.seeAllProjects') }}
        </v-list-item>
      </div>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

import { getRoomIcon, getRoomRouteType } from '@/common/utils/rooms'
import { toast } from '@/common/utils/toast'
import { ROOM_ROUTE_NAME, ROOMS_ROUTE_NAME } from '@/router/routerData'
import { GET_LAST_VISITED_ROOMS } from '@/store/modules/rooms/action_types'

const LAST_VISITED_ROOMS_LIMIT = 5

export default {
  name: 'ProjectsMenuItem',
  data() {
    return {
      projectsHomeRoute: {
        name: ROOMS_ROUTE_NAME,
      },
    }
  },
  computed: {
    ...mapState('room', ['currentRoom']),
    ...mapState('rooms', ['lastVisitedRooms', 'lastVisitedRoomsPending']),
    ...mapGetters('room', ['roomMnemo']),
  },
  methods: {
    ...mapActions('rooms', [GET_LAST_VISITED_ROOMS]),
    goToProject(project) {
      if (!this.currentRoom || this.currentRoom.id !== project.id) {
        this.$router.push({
          name: ROOM_ROUTE_NAME,
          params: {
            mnemo: project.mnemo,
            roomType: getRoomRouteType(project),
          },
        })
      }
    },
    goToProjects() {
      if (this.$route.path !== '/') {
        this.$router.push(this.projectsHomeRoute)
      }
    },
    getRoomIcon,
    async loadLastVisitedRooms() {
      try {
        await this.GET_LAST_VISITED_ROOMS(LAST_VISITED_ROOMS_LIMIT)
      } catch (error) {
        console.error(error)

        toast.error(this.$t('common.app-bar.ProjectsMenuItem.loadLastVisitedRoomsError'))
      }
    },
    onMenuToggle (isMenuOpened) {
      if (isMenuOpened) {
        this.loadLastVisitedRooms()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v-list-item__content {
  span {
    max-width: 206px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

.project-list-item.v-list-item--active {
  &::before {
    opacity: 0 !important;
  }

  &:hover {
    &::before {
      opacity: 0.04 !important;
    }
  }
}
</style>
